module.exports = __webpack_public_path__ + "assets1779866876160/img/lan2.eddb60b0.png";